module.exports = {"TXTWCL_All_N0_Markets":{"id":"TXTWCL_All_N0_Markets","defaultMessage":"Alla speltyper för {0}"}}